// Circuit Breaker: öffnet nach 3 Fehlschlägen für 5 Min
// ES Module format for Clara360 VPS stability (FIXED: converted from CommonJS)

const state = new Map(); // key -> { openUntil, failures }

export function allowCall(key) {
  const s = state.get(key);
  return !s || Date.now() > s.openUntil;
}

export function reportResult(key, ok) {
  const s = state.get(key) || { openUntil: 0, failures: 0 };
  s.failures = ok ? 0 : (s.failures + 1);
  if (!ok && s.failures >= 3) s.openUntil = Date.now() + 5 * 60 * 1000;
  state.set(key, s);
}

export function status(key) {
  const s = state.get(key) || { openUntil: 0, failures: 0 };
  return { 
    open: Date.now() < s.openUntil, 
    failures: s.failures, 
    openUntil: s.openUntil 
  };
}

